import React, { useState, useRef, useEffect } from 'react';
import {
  FilterPod,
  TableComponents,
  ConfirmDialog,
  ButtonLoading,
  SimpleDialog,
  ExportButton,
  Icons

} from 'components';
import createToast from 'components/Toast/Toast';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { makeStyles } from '@mui/styles';
import { CircularProgress, Grid, Menu, MenuItem, Typography, IconButton, Box } from '@mui/material';
import copy from 'copy-to-clipboard';
import { useBusiness } from 'hooks';
import { useExportFile } from 'hooks';
import jMoment from 'moment-jalaali';
import InitFilters from './constants/InitFiltering';
import Services from './services/RequestedServices';
import { columns, generateData } from './components/Columns';
import { enifyNumber, numberTester, enifyDateTime } from '../../../utility';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';
import {
  getExportSentRequestsUrl,
} from 'URLs';
jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

const AssignedDelegation = () => {
  // -- STATES --//
  const [loading, setLoading] = useState(false);
  const [cancelingRequest, setCancelingRequest] = useState(false);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(null);

  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);

  const actionsList =
    getDynamicObjectAction([
      'exportRequestListBtn',
    ])
  // It should be declared here cause of hierarchy!
  const getAccounts = async (val) => {
    if (val?.length >= 2) {
      try {
        const q = {
          size: 10,
          offset: 0,
        };

        const enifiedValue = enifyNumber(val);
        q[numberTester.test(enifiedValue) ? 'businessId' : 'query'] = enifiedValue;

        const result = await Services.getBusinessList(q);
        const data = result.result;
        let list = [];
        list = data.map((val) => ({
          name: val.name,
          id: val.id,
          label: `${val.name} (شناسه: ${val?.id})`,
          value: val.id,
        }));
        return list;
      } catch (e) {
        console.log('e :', e);
        return [];
      }
    }
  };
  const [filters, setFilters] = useState(InitFilters(getAccounts));
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  // --HOOKS--//
  const classes = useStyles();
  const tableRef = useRef();
  const { downloadFile, isExporting } = useExportFile({
    url: getExportSentRequestsUrl(),
    filename: 'submited-requests-list',
  });

  // --API REQUESTS--//
  const getRequestsData = async (query) => {
    try {
      setLoading(true);

      // TODO: Handle Order By (is not provided by server side)
      const orderBy = [];

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      jMoment.loadPersian({ usePersianDigits: false });

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        fromDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD 00:00:00')),
        toDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD 23:59:59')),
        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await Services.getRequests(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const deleteService = async () => {
    if (!selectedRowToDelete) return;
    try {
      setCancelingRequest(true);
      const params = {
        productId: selectedRowToDelete.product.id,
      };
      await Services.deleteApiKeyApi(params, selectedRowToDelete.id);

      createToast('موفق', 'درخواست با موفقیت لغو شد!', 'success')
      handleCloseDialog();
      setCancelingRequest(false);
      tableRef?.current?.onQueryChange?.();
    } catch (e) {
      console.log(`error`, e);

      setCancelingRequest(false);
    }
  };

  const onDeleteReq = (rowData) => {
    setSelectedRowToDelete(rowData ?? null);
    setIsConfirmOpen(!!rowData);
  };

  const handleCloseDialog = () => {
    setSelectedRowToDelete(null);
    setIsConfirmOpen(false);
  };

  /**
   * زمانیکه رو دکمه خروجی فایل کلیک میشود و میخوایم اکسپورت دریافت کنیم  -فیلدهای ارسالی برای سرویس خروجی فایل همون نامی که سرویس دریافت میکند ارسال میشود
   */
  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    let p = JSON.stringify(filterParams?.params);
    p = JSON.parse(p);
    p['endDate'] = p?.toDate;
    p['startDate'] = p?.fromDate;

    delete p['fromDate'];
    delete p['toDate'];
    p['statusCode'] && delete p['statusCode'];
    downloadFile(types[index], filterParams?.data, p);
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const copyItem = (item, title = 'متن مورد نظر') => {
    if (!item) return;
    try {
      copy(item);
      createToast('موفق', `${title} با موفقیت کپی شد!`, 'success')
    } catch (error) {
      createToast('خطا', `خطا در کپی کردن ${title}!`, 'danger')
    }
  };

  return (
    <div className={classes.root}>
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ margin: "16px 0" }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={filters}
          />
          {actionsList['exportRequestListBtn'] && (
            <ExportButton
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          )}
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      <TableComponents
        data={getRequestsData}
        columns={columns(onDeleteReq, copyItem)}
        isLoading={loading}
        ref={tableRef}
        onChange={(ps) => {
          setPage(ps?.pageNumber)
          setSize(ps?.pageSize)
          return getRequestsData(ps)
        }}
      />

      {/* Confirm Delete Request */}
      <ConfirmDialog
        open={isConfirmOpen}
        onClose={handleCloseDialog}
        onConfirm={deleteService}
        title="تایید لغو درخواست"
        loading={cancelingRequest}
        content={`آیا از لغو درخواست سرویس ${selectedRowToDelete?.product?.name ?? 'مورد نظر'
          } اطمینان دارید؟`}
        confirmButtonText="بله، لغو درخواست"
        cancelButtonProps="انصراف"
      />
    </div>
    // </PageContainer>
  );
};

// See detail for every row

const TableItemActions = ({ otherMenus, startIcon, title, rowData, copyItem = () => { } }) => {
  const [localApiKey, setLocalApiKey] = useState(null);
  const [generatingApiKey, setGeneratingApiKey] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // --HOOKS--//
  const classes = useStyles();
  const businessInfo = useBusiness();

  useEffect(() => {
    setLocalApiKey(rowData?.apiKey);
  }, [rowData]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // --API--//
  const generateApiKey = async () => {
    // Check Errors
    let initError = null;
    if (!rowData?.id) initError = 'شناسه سرویس مشخص نشده است!';
    if (!businessInfo?.id) initError = 'شناسه کسب‌وکار مشخص نشده است!';

    if (initError) {

      createToast('خطا', initError, 'danger')

      return;
    }

    // Main Req.
    try {
      setGeneratingApiKey(true);
      const data = {
        businessId: businessInfo.id,
      };
      const res = await Services.generateApiKeyApi(data, rowData?.id);
      setGeneratingApiKey(false);
      if (res?.result?.apiKey) {
        setLocalApiKey(res?.result?.apiKey);
        // copyItem(res.result.apiKey, 'مقدار API KEY');
      }
    } catch (e) {
      setIsDialogOpen(false);
      setTimeout(() => {
        setGeneratingApiKey(false);
      }, 500);

    }
  };

  return (
    <div className={classes.otherActions}>
      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={isDialogOpen}
        title={`دریافت API Key جدید برای سرویس: ${rowData?.product?.name}`}
        onClose={() => setIsDialogOpen(false)}
      // actions={<ActionsBtn />}
      >
        <Grid
          justifyContent="center"
          direction="column"
          container
          alignItems="center"
          style={{ marginTop: 8, marginBottom: 8 }}
        >
          {generatingApiKey ? (
            <CircularProgress />
          ) : localApiKey ? (
            <>
              <Typography>مقدار API Key جدید ایجاد شده برای سرویس:</Typography>
              <Typography className={classes.generatedApiKey}>
                <IconButton
                  className={classes.copyIcon}
                  onClick={() => copyItem(localApiKey, 'مقدار API Key')}
                  size="large">
                  <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />
                </IconButton>
                <b>{localApiKey}</b>
              </Typography>
            </>
          ) : null}
        </Grid>
      </SimpleDialog>
      <ButtonLoading
        variant="outlined"
        onClick={handleClick}
        color="primary"
        startIcon={startIcon ?? null}
        name={title ?? 'عملیات'}
        aria-controls="simple-menu"
        aria-haspopup="true"
      />

      <Menu
        id="simple-menu"
        className={classes.otherActionsMenu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
      >
        <MenuItem
          className={classes.otherActionsMenuItem}
          disabled={!localApiKey}
          onClick={() => {
            if (!localApiKey) return;
            copyItem?.(localApiKey, 'مقدار API Key');
            handleClose();
          }}
        >
          کپی‌کردن API Key
        </MenuItem>
        <MenuItem
          className={classes.otherActionsMenuItem}
          disabled={rowData?.statusCode !== 'CLIENT_API_KEY_STATUS_CONFIRMED'}
          onClick={() => {
            if (!rowData?.id || rowData?.statusCode !== 'CLIENT_API_KEY_STATUS_CONFIRMED') return;
            setIsDialogOpen(true);
            generateApiKey(rowData?.id);
            handleClose();
          }}
        >
          دریافت API Key جدید
        </MenuItem>
        {otherMenus.map((v, k) => (
          <MenuItem
            className={classes.otherActionsMenuItem}
            key={k}
            disabled={v?.disabled}
            onClick={() => {
              if (v?.disabled) return;
              v?.onClick?.();
              handleClose();
            }}
          >
            {v?.title}
          </MenuItem>
        ))}
        <MenuItem onClick={() => handleClose()}>انصراف</MenuItem>
      </Menu>
    </div>
  );
};
const darkGray = '#263238';
const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
    '& .MuiIconButton-root': {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff'
    }
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
  otherActions: {
    marginLeft: 'auto !important',
    marginRight: 'o !important',
  },
  otherActionsMenu: {
    border: '1px solid #d8d1d1',
    '& .MuiButtonBase-root.Mui-disabled': {
      pointerEvents: 'auto !important',
    },
  },
  otherActionsMenuItem: {
    padding: theme.spacing(1.5),
    color: darkGray,
    minWidth: 160,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  generatedApiKey: {
    background: theme.palette.grey[200],
    padding: theme.spacing(1, 2),
    paddingInlineStart: theme.spacing(1),
    borderRadius: 4,
    textAlign: 'center',
    fontSize: 15,
    marginTop: theme.spacing(2),
    '& b': {
      fontFamily: 'Vazir',
    },
  },
  copyIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: theme.spacing(1),
    marginTop: -2,
  },
}));

export default AssignedDelegation;
